import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { updateDashboardGesamtpreisSaga } from './updateGesamtpreisSaga';
import { watchZaehlstueckLogik } from './zaehlstueckSaga';
import { initSpeichernVermerkSaga } from './initSpeichernVermerkSaga';
import { notificationSaga } from './notificationSaga';
import { watchSofortschutzRelevantEvents } from './sofortschutzAvailableSaga';
import { quoteDbSaga } from './quoteDbSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { vorvertragsUebersichtSaga } from './vorvertragsUebersichtSaga';
import { watchDeleteAngebotRequested } from './deleteWarningSaga';
import { watchImmobilieAusVorvertragRequested } from './immobilienDialogSaga';
import { watchStandaloneEinschliessen } from './standaloneSaga';
import { watchShowDashboardModal } from './showModalSaga';
import { watchPersonenSucheAndUpdateVertraegeSaga } from './personensucheAndUpdateVertraegeSaga';
import { multiVertragSaga } from './multiVertragSaga';
import { appIdsInWarenkorbProviderSaga } from './appIdsInWarenkorbProviderSaga';
import { provideMultiangebotAdressValidationSaga } from './multiangebotAdressvalidierung/provideMultiangebotAdressValidationSaga';
import { provideVorvertragStatusValidationSaga } from './vorvertragStatusValidierung/provideVorvertragStatusValidationSaga';
import { requestStructuredRisikoortSaga } from './requestStructuredRisikoortSaga';
import { hauptfaelligkeitProviderSaga } from './hauptfaelligkeitProviderSaga';
import { vorvertragHinweisModalWithOptionenRequests } from './vorvertragHinweisModalWithOptionenSaga';
import { vorvertragUmstellenWatch } from './vorvertragUmstellenSaga';
import { beibehaltungSaga } from './beibehaltungSaga';
import { watchUwDecisionSubmitted } from './uwDecisionZuschlagSaga';
import { requestForwardToUnderwriterSaga } from './requestForwardToUnderwriterSaga';
import { requestForwardToAgentSaga } from './requestForwardToAgentSaga';
import { watchFileDeleted } from './fileDeletionSaga';
import { watchFilesAfterLoad } from './checkFilesAfterLoadSaga';
import { watchFileDownload } from './fileDownloadSaga';
import { watchAngebotsdatumResetLog } from './angebotsdatumLoggingSaga';
import { watchOfferSavedWithCryptId } from './updateVwgDocumentsAfterSaveSaga';
import { watchCleanupLoadedProducts } from './cleanupLoadedProductsSaga';
import { watchNavigateToCheckoutRequested } from './checkoutNavigationSaga';
import { watchUwResubmissionFulfilledAngebote } from './uwResubmissionFulfilledAngeboteSaga';
import { watchTgvGroupLaufzeit } from './tgvGroupLaufzeitSaga';

export function* rootSaga() {
  yield all([
    updateDashboardGesamtpreisSaga(),
    watchZaehlstueckLogik(),
    notificationSaga(),
    initSpeichernVermerkSaga(),
    watchSofortschutzRelevantEvents(),
    quoteDbSaga(),
    watchStateSnapshot(),
    appIdsInWarenkorbProviderSaga(),
    provideMultiangebotAdressValidationSaga(),
    provideVorvertragStatusValidationSaga(),
    requestStructuredRisikoortSaga(),
    vorvertragsUebersichtSaga(),
    watchDeleteAngebotRequested(),
    watchImmobilieAusVorvertragRequested(),
    watchStandaloneEinschliessen(),
    watchShowDashboardModal(),
    watchPersonenSucheAndUpdateVertraegeSaga(),
    multiVertragSaga(),
    hauptfaelligkeitProviderSaga(),
    vorvertragHinweisModalWithOptionenRequests(),
    vorvertragUmstellenWatch(),
    beibehaltungSaga(),
    requestForwardToUnderwriterSaga(),
    requestForwardToAgentSaga(),
    watchUwDecisionSubmitted(),
    watchFileDeleted(),
    watchFilesAfterLoad(),
    watchFileDownload(),
    watchAngebotsdatumResetLog(),
    watchOfferSavedWithCryptId(),
    watchCleanupLoadedProducts(),
    watchNavigateToCheckoutRequested(),
    watchUwResubmissionFulfilledAngebote(),
    watchTgvGroupLaufzeit(),
  ]);
}
